var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.content))]),_c('div',{ref:"textRef",staticClass:"overflow-text truncate",style:({ textOverflow: _vm.overfloType })},[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }